<template>
  <div
    class="d-flex align-items-center justify-content-center action"
    v-if="row"
  >
    <div
      :title="$t('deleteFinally')"
      v-if="canDeleteFinally"
      class="cursor-pointer mr-1"
      @click="deleteCase(row.id)"
    >
      <feather-icon size="16" icon="TrashIcon" style="color: red" />
    </div>
    <div
      v-if="canShow"
      class="cursor-pointer mr-1 "
      @click="$router.push(`/my-cases/${row.id}/show`)"
    >
      <feather-icon size="16" icon="EyeIcon" />
    </div>
    <div
      v-if="canEdit"
      class="cursor-pointer"
      @click="$router.push(`/my-cases/${row.id}/edit`)"
    >
      <feather-icon size="16" icon="Edit2Icon" />
    </div>
    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center"
      class=""
    >
      <template #button-content>
        <div class="">
          <ElementIcon v-bind:icon="'barVerticalIcon'" />
        </div>
      </template>
      <b-dropdown-item
        v-if="canPreviewOriginalRegistered"
        @click="
          handlePreviewClick(
            row.files ? row.files['upper_portal'] : null,
            row.files ? row.files['lower_portal'] : null,
            row.results ? row.results['upper_rotated'] : null,
            row.results ? row.results['lower_rotated'] : null
          )
        "
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="InfoIcon" class="mr-50" />
        <span>{{ $t("previewCase") }}</span>
      </b-dropdown-item>
      <!-- <b-dropdown-item
        v-if="canDownloadOriginalAI"
        link-class="d-flex align-items-center"
        @click="downloadFiles([row.files['upper'], row.files['lower']])"
      >
        <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
        <span>{{ $t("downloadOriginalUsedForAI") }}</span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="canDownloadOriginal"
        link-class="d-flex align-items-center"
        @click="
          downloadFiles([
            row.files['upper_portal_original'],
            row.files['lower_portal_original'],
          ])
        "
      >
        <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
        <span>{{ $t("downloadOriginal") }}</span>
      </b-dropdown-item> -->
      <!-- <b-dropdown-item
        v-if="canPreviewOriginalRegistered"
        @click="
          handlePreviewClick(
            row.files['upper_portal'],
            row.files['lower_portal']
          )
        "
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="InfoIcon" class="mr-50" />
        <span>{{ $t("previewOriginalRegistered") }}</span>
      </b-dropdown-item> -->
      <!-- <b-dropdown-item
        v-if="canDownloadOriginalRegistered"
        link-class="d-flex align-items-center"
        @click="
          downloadRegisteredFiles([
            row.files['upper_portal'],
            row.files['lower_portal'],
          ])
        "
      >
        <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
        <span>{{ $t("downloadOriginalRegistered") }}</span>
      </b-dropdown-item> -->
      <div v-if="row.results || row.caseResultsHistory.length > 0">
        <!-- <b-dropdown-item
          @click="
            handlePreviewResultClick([
              row.results['upper_rotated'],
              row.results['lower_rotated'],
            ])
          "
          link-class="d-flex align-items-center"
        >
          <feather-icon size="16" icon="InfoIcon" class="mr-50" />
          <span>{{ $t("previewResult") }}</span>
        </b-dropdown-item> -->
        <b-dropdown-item
          v-if="canDownloadResult"
          @click="downloadResultFiles(row)"
          link-class="d-flex align-items-center"
        >
          <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
          <span>{{ $t("downloadResult") }}</span>
        </b-dropdown-item>
        <!-- <b-dropdown-item
          @click="
            handlePreviewResultClick([
              row.results['upper'],
              row.results['lower'],
            ])
          "
          link-class="d-flex align-items-center"
        >
          <feather-icon size="16" icon="InfoIcon" class="mr-50" />
          <span>{{ $t("previewResultDeregistered") }}</span>
        </b-dropdown-item> -->
        <b-dropdown-item
          v-if="canDownloadResultDeregistered"
          @click="downloadFiles([row.results['upper'], row.results['lower']])"
          link-class="d-flex align-items-center"
        >
          <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
          <span>{{ $t("downloadResultDeregistered") }}</span>
        </b-dropdown-item>
      </div>
      <b-dropdown-item
        v-if="canRecalculate"
        @click="replicateCase(row.id)"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="CopyIcon" class="mr-50" />
        <span>{{ $t("recalculate") }}</span>
      </b-dropdown-item>
      <!--  <b-dropdown-item
        v-if="canRejectCase"
        @click="approveCase(row.id, 'rejected')"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="XIcon" class="mr-50" />
        <span>{{ $t("rejectCase") }}</span>
      </b-dropdown-item> -->
      <b-dropdown-item
        v-if="canReportCase"
        @click="reportCase(row)"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="FlagIcon" class="mr-50" />
        <span>{{ $t("reportCase") }}</span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="canUpdateStatusToTrash"
        @click="updateStatus(row.id, 'trash')"
        link-class="d-flex align-items-center"
      >
        <feather-icon size="16" icon="TrashIcon" class="mr-50" />
        <span>{{ $t("trash") }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileService from "@/services/file.service";
import ElementIcon from "@/components/elements/Icon.vue";
export default {
  emits: [
    "loadItems",
    "handlePreviewClick",
    "handlePreviewResultClick",
  ],
  components: {
    ElementIcon,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canDeleteFinally() {
      return (
        this.row.status == "trash" &&
        this.$can(`${this.$route.meta.permission}.delete`)
      );
    },
    canEdit() {
      return this.$can(`${this.$route.meta.permission}.edit`);
    },
    canShow() {
      return (
        this.$can(`${this.$route.meta.permission}.list`) ||
        this.$can(`${this.$route.meta.permission}.show-all`)
      );
    },
    canDownloadOriginalAI() {
      return (
        (this.row?.files?.["upper"] || this.row?.files?.["lower"]) &&
        this.$can(`${this.$route.meta.permission}.download-original`)
      );
    },
    canDownloadOriginal() {
      return (
        (this.row?.files?.["upper_portal_original"] ||
          this.row?.files?.["lower_portal_original"]) &&
        this.$can(`${this.$route.meta.permission}.download-original`)
      );
    },
    canPreviewOriginalRegistered() {
      return this.row?.files?.["upper_portal"] || this.row?.files?.["lower_portal"];
    },
    canDownloadOriginalRegistered() {
      return this.$can(
        `${this.$route.meta.permission}.download-original-registered`
      );
    },
    canDownloadResult() {
      return this.$can(`${this.$route.meta.permission}.download-result`);
    },
    canDownloadResultDeregistered() {
      return this.$can(
        `${this.$route.meta.permission}.download-result-deregistered`
      );
    },
    canApproveCase() {
      return this.$can(`${this.$route.meta.permission}.approve-case`);
    },
    canRecalculate() {
      return (
        this.$can(`${this.$route.meta.permission}.recalculate`) ||
        this.$can("recalculate-case-from-backoffice.create")
      );
    },
    canRejectCase() {
      return this.$can(`${this.$route.meta.permission}.reject-case`);
    },
    canUpdateStatusToFinished() {
      return this.$can(`${this.$route.meta.permission}.edit`);
    },
    canReportCase() {
      return (
        this.$can("backoffice-ticket.create") &&
        this.$can(`${this.$route.meta.permission}.report-case`)
      );
    },
    canUpdateStatusToTrash() {
      return this.$can(`${this.$route.meta.permission}.edit`);
    },
  },
  methods: {
    async deleteCase(id) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouReallyWantToCompletelyDeleteThisCase"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        await this.$store.dispatch("caseLists/destroy", id).finally(() => {
          this.$emit("loadItems");
        });
      }
    },
    downloadRegisteredFiles(array) {
      FileService.downloadRegisteredFiles(array, this.$store);
    },
    downloadFiles(array) {
      FileService.downloadFiles(array, this.$store);
    },
    async downloadResultFiles(caseItem) {
      const sanitizedCaseName =
        caseItem.name.replace(/\s+/g, "_") ?? "case";

      const jawFiles = caseItem.caseResultsHistory.map((result) => ({
        fileId: result.fileId,
        type: result.type,
      }));

      let filesToDownload = [];

      const constructioninfoFileId = caseItem.constructioninfoFile?.fileId;
      
      if (jawFiles?.length) {
        const fileIds = jawFiles.map((file) => file.fileId);

        const allDentaBridge = jawFiles.every((f) => f.type === "DentaBridge Result");
        const allUpper = jawFiles.every((f) => f.type === "Upper Jaw Result");
        const allLower = jawFiles.every((f) => f.type === "Lower Jaw Result");

        if (!allDentaBridge && allUpper) {
          if (caseItem.results["lower"]) {
            fileIds.push(caseItem.results["lower"]);
          } else if (caseItem.results["lower_rotated"]) {
            fileIds.push(caseItem.results["lower_rotated"]);
          }
        } else if (!allDentaBridge && allLower) {
          if (caseItem.results["upper_rotated"]) {
            fileIds.push(caseItem.results["upper_rotated"]);
          } else if (caseItem.results["upper"]) {
            fileIds.push(caseItem.results["upper"]);
          }
        }

        if (constructioninfoFileId) {
          fileIds.push(constructioninfoFileId);
        }

        if (fileIds.length === 1) {
          FileService.downloadFiles(fileIds, this.$store);
        } else {
          FileService.downloadZipFiles(
            {
              files: fileIds,
              zipName: `results_${sanitizedCaseName}.zip`,
            },
            this.$store
          );
        }
      } else {
        if (caseItem.results["upper_rotated"]) {
          filesToDownload.push(caseItem.results["upper_rotated"]);
        } else if (caseItem.results["upper"]) {
          filesToDownload.push(caseItem.results["upper"]);
        }

        if (caseItem.results["lower"]) {
          filesToDownload.push(caseItem.results["lower"]);
        } else if (caseItem.results["lower_rotated"]) {
          filesToDownload.push(caseItem.results["lower_rotated"]);
        }

        if (constructioninfoFileId) {
          filesToDownload.push(constructioninfoFileId);
        }

        if (filesToDownload.length === 1) {
          FileService.downloadFiles(filesToDownload, this.$store);
        } else {
          FileService.downloadZipFiles(
            {
              files: filesToDownload,
              zipName: `results_${sanitizedCaseName}.zip`,
            },
            this.$store
          );
        }
      }
    },
    handlePreviewClick(upperOriginal, lowerOriginal, upperResult, lowerResult) {
      this.$emit("handlePreviewClick", {
        upperOriginal,
        lowerOriginal,
        upperResult,
        lowerResult,
      });
    },
    handlePreviewResultClick(results) {
      this.$emit("handlePreviewResultClick", results);
    },
    async approveCase(id, status) {
      const title =
        status === "approved"
          ? this.$t("doYouWantToApproveThisRecord")
          : this.$t("doYouWantToRejectThisRecord");
      const subText =
        status === "approved"
          ? this.$t("yesApproveIt")
          : this.$t("yesRejectIt");
      const confirmed = await this.showConfirmationDialog({
        title: title,
        subText: subText,
      });

      if (confirmed) {
        await this.$store
          .dispatch("caseLists/approveRejectCase", {
            caseId: id,
            status: status,
          })
          .finally(() => {
            this.$emit("loadItems");
          });
      }
    },
    async replicateCase(id) {
      const payload = {
        caseId: id,
        extensions: [{ id: "opg-to-3d" }],
      };
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToRecalculateThisRecord"),
        subText: this.$t("yesRecalculateIt"),
      });

      if (confirmed) {
        await this.$store
          .dispatch("caseLists/replicateCase", payload)
          .finally(() => {
            this.$emit("loadItems");
          });
      }
    },
    async updateStatus(id, status) {
      const title =
        status === "trash"
          ? this.$t("doYouWantToDeleteThisRecord")
          : this.$t("doYouWantToUpdateThisRecord");
      const subText =
        status === "trash"
          ? this.$t("yesDeleteIt")
          : this.$t("yesUpdateIt");
      const confirmed = await this.showConfirmationDialog({
        title: title,
        subText: subText,
      });

      if (confirmed) {
        await this.$store
          .dispatch("caseLists/updateStatus", {
            caseId: id,
            status: status,
          })
          .finally(() => {
            this.$emit("loadItems");
          });
      }
    },
    reportCase(reportedCase) {
      this.$store.commit("caseLists/reportCaseID", reportedCase);
      this.$router.push("/tickets/create");
    },
  },
};
</script>

<style lang="scss">
.action {
  li {
    list-style: none;
    margin: 0;
    padding: 0;
    .dropdown-toggle {
      svg {
        width: 22px;
        height: 22px;
        path {
          fill: #0a1724;
          stroke: #0a1724;
        }
      }
      &::after {
        display: none;
      }
    }
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
